<div class="balanceContainer row">
  <div class="text-center">
    <p  class="marginZero opacity-75">{{heading}}</p>
    <h1 class="text-light">{{sign}} {{amount}}</h1>
  </div>
</div>
